import { render } from "./UserReportView.vue?vue&type=template&id=38970022&scoped=true"
import script from "./UserReportView.vue?vue&type=script&lang=js"
export * from "./UserReportView.vue?vue&type=script&lang=js"

import "./UserReportView.vue?vue&type=style&index=0&id=38970022&lang=less&scoped=true"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38970022"]])

export default __exports__